
export const HOST = process.env.REACT_APP_BACKEND_HOST || "http://127.0.0.1:8000/";

export const CLIENT = process.env.REACT_APP_CLIENT?.toUpperCase() || "TECSO";

// STYLES
export const PRIMARY = process.env.REACT_APP_PRIMARY || "#FF6200";
export const SECONDARY = process.env.REACT_APP_SECONDARY || "#3C096C";
export const TERTIARY = process.env.REACT_APP_TERTIARY || "#9D4EDD";

export const SUCCESS = process.env.REACT_APP_SUCCESS || "#16B208";
export const WARNING = process.env.REACT_APP_WARNING || "#FFC700";
export const ERROR = process.env.REACT_APP_ERROR || "#D00307";

export const LOGIN_BACKGROUND = process.env.REACT_APP_LOGIN_BACKGROUND || "#ECBC2C";
export const BACKGROUND = process.env.REACT_APP_BACKGROUND || "#FAFAFA";

export const NEUTRAL_0 = process.env.REACT_APP_NEUTRAL_0 || "#000000";
export const NEUTRAL_1 = process.env.REACT_APP_NEUTRAL_1 || "#1A1A1A";
export const NEUTRAL_2 = process.env.REACT_APP_NEUTRAL_2 || "#808080";
export const NEUTRAL_3 = process.env.REACT_APP_NEUTRAL_3 || "#CDCDCD";
export const NEUTRAL_4 = process.env.REACT_APP_NEUTRAL_4 || "#F7F7F7";
export const NEUTRAL_5 = process.env.REACT_APP_NEUTRAL_5 || "#FFFFFF";

export const COMPLEMENTARY_1 = JSON.parse(process.env.REACT_APP_COMPLEMENTARY_1_DARK || '{"P":"#38DAAD","B":"#E0F9F2"}');
export const COMPLEMENTARY_2 = JSON.parse(process.env.REACT_APP_COMPLEMENTARY_2_DARK || '{"P":"#9229FE","B":"#D3CBF8"}');
export const COMPLEMENTARY_3 = JSON.parse(process.env.REACT_APP_COMPLEMENTARY_3_DARK || '{"P":"#0049D0","B":"#E0EBF9"}');
export const COMPLEMENTARY_4 = JSON.parse(process.env.REACT_APP_COMPLEMENTARY_4_DARK || '{"P":"#D20E55","B":"#F9E0E0"}');
export const COMPLEMENTARY_5 = JSON.parse(process.env.REACT_APP_COMPLEMENTARY_5_DARK || '{"P":"#EE9315","B":"#F9ECE0"}');
export const COMPLEMENTARY_6 = JSON.parse(process.env.REACT_APP_COMPLEMENTARY_6_DARK || '{"P":"#858585","B":"#E1E1E1"}');
export const COMPLEMENTARY_7 = JSON.parse(process.env.REACT_APP_COMPLEMENTARY_7_DARK || '{"P":"#FFD338","B":"#FDD8884D"}');
export const COMPLEMENTARY_8 = JSON.parse(process.env.REACT_APP_COMPLEMENTARY_8_DARK || '{"P":"#16B208","B":"#CDEDCB"}');
export const COMPLEMENTARY_9 = JSON.parse(process.env.REACT_APP_COMPLEMENTARY_9_DARK || '{"P":"#00B4D4","B":"rgba(76, 194, 215, 0.15)"}');

//DARK MODE
export const PRIMARY_DARK = process.env.REACT_APP_PRIMARY_DARK || "#ff5722";
export const SECONDARY_DARK = process.env.REACT_APP_SECONDARY_DARK || "#3C096C";
export const TERTIARY_DARK = process.env.REACT_APP_TERTIARY_DARK || "#9D4EDD";

export const SUCCESS_DARK = process.env.REACT_APP_SUCCESS_DARK || "#16B208";
export const WARNING_DARK = process.env.REACT_APP_WARNING_DARK || "#FFC700";
export const ERROR_DARK = process.env.REACT_APP_ERROR_DARK || "#e53935";

export const LOGIN_BACKGROUND_DARK = process.env.REACT_APP_LOGIN_BACKGROUND_DARK || "#ECBC2C";
export const BACKGROUND_DARK = process.env.REACT_APP_BACKGROUND_DARK || "#1A1A1A";

export const NEUTRAL_0_DARK = process.env.REACT_APP_NEUTRAL_0_DARK || "#FFFFFF";
export const NEUTRAL_1_DARK = process.env.REACT_APP_NEUTRAL_1_DARK || "#F7F7F7";
export const NEUTRAL_2_DARK = process.env.REACT_APP_NEUTRAL_2_DARK || "#CDCDCD";
export const NEUTRAL_3_DARK = process.env.REACT_APP_NEUTRAL_3_DARK || "#808080";
export const NEUTRAL_4_DARK = process.env.REACT_APP_NEUTRAL_4_DARK || "#1A1A1A";
export const NEUTRAL_5_DARK = process.env.REACT_APP_NEUTRAL_5_DARK || "#000000";

export const COMPLEMENTARY_1_DARK = JSON.parse(process.env.REACT_APP_COMPLEMENTARY_1_DARK || '{"P":"#38DAAD","B":"#E0F9F2"}');
export const COMPLEMENTARY_2_DARK = JSON.parse(process.env.REACT_APP_COMPLEMENTARY_2_DARK || '{"P":"#9229FE","B":"#D3CBF8"}');
export const COMPLEMENTARY_3_DARK = JSON.parse(process.env.REACT_APP_COMPLEMENTARY_3_DARK || '{"P":"#0049D0","B":"#E0EBF9"}');
export const COMPLEMENTARY_4_DARK = JSON.parse(process.env.REACT_APP_COMPLEMENTARY_4_DARK || '{"P":"#D20E55","B":"#F9E0E0"}');
export const COMPLEMENTARY_5_DARK = JSON.parse(process.env.REACT_APP_COMPLEMENTARY_5_DARK || '{"P":"#EE9315","B":"#F9ECE0"}');
export const COMPLEMENTARY_6_DARK = JSON.parse(process.env.REACT_APP_COMPLEMENTARY_6_DARK || '{"P":"#858585","B":"#E1E1E1"}');
export const COMPLEMENTARY_7_DARK = JSON.parse(process.env.REACT_APP_COMPLEMENTARY_7_DARK || '{"P":"#FFD338","B":"#FDD8884D"}');
export const COMPLEMENTARY_8_DARK = JSON.parse(process.env.REACT_APP_COMPLEMENTARY_8_DARK || '{"P":"#16B208","B":"#CDEDCB"}');
export const COMPLEMENTARY_9_DARK = JSON.parse(process.env.REACT_APP_COMPLEMENTARY_9_DARK || '{"P":"#00B4D4","B":"rgba(76, 194, 215, 0.15)"}');



export const APP_LOGO = process.env.REACT_APP_APP_LOGO || "lotia_logo.png";
export const APP_LOGO_TABLET = process.env.REACT_APP_APP_LOGO_TABLET || 'lotia_icon_yellow.png';
export const APP_LOGO_LOGIN = process.env.REACT_APP_APP_LOGO_LOGIN || "lotia_logo_white_x4.png";
export const APP_LOGO_REPORT = process.env.REACT_APP_APP_LOGO_REPORT || "lotia_logo.png";